var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tg",
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "tg-rect",
    x: 0.5,
    y: 1.4375,
    width: 39,
    height: 39,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tg-path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3749 20.0727C16.7436 17.7337 20.3236 16.1916 22.1148 15.4466C27.2292 13.3194 28.2919 12.9498 28.9846 12.9376C29.1369 12.9349 29.4776 12.9727 29.6982 13.1517C29.8845 13.3029 29.9358 13.5071 29.9603 13.6505C29.9848 13.7938 30.0154 14.1203 29.9911 14.3755C29.714 17.2875 28.5147 24.3542 27.9046 27.6158C27.6465 28.9958 27.1382 29.4586 26.6461 29.5038C25.5766 29.6023 24.7645 28.7971 23.7287 28.1181C22.1078 27.0556 21.1921 26.3942 19.6188 25.3574C17.8005 24.1592 18.9792 23.5006 20.0155 22.4244C20.2866 22.1427 24.9987 17.8567 25.0899 17.4679C25.1013 17.4193 25.1119 17.238 25.0042 17.1423C24.8965 17.0466 24.7376 17.0793 24.6229 17.1053C24.4604 17.1422 21.871 18.8537 16.8549 22.2397C16.1199 22.7444 15.4542 22.9903 14.8577 22.9774C14.2001 22.9632 12.9353 22.6057 11.995 22.3C10.8417 21.9251 9.92503 21.7269 10.0048 21.0902C10.0464 20.7586 10.5031 20.4194 11.3749 20.0727Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.07fda389dcb7f324fc774e89795b82f0.svg";
export { ForwardRef as ReactComponent };